import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from '@/context/AuthContext'
import { Box, CircularProgress } from '@mui/joy'

import LoginPage from '@/pages/LoginPage'
import ForgotPasswordPage from '@/pages/ForgotPasswordPage'
import ResetPasswordPage from '@/pages/ResetPasswordPage'
import DashboardPage from '@/pages/DashboardPage'
import UsersPage from '@/pages/UsersPage'
import ShiftTypesPage from '@/pages/ShiftTypesPage'
import SchedulePage from '@/pages/SchedulePage'
import CalendarPage from '@/pages/CalendarPage'
import AdminPermissionsPage from '@/pages/AdminPermissionsPage'
import ChangeRequestsPage from '@/pages/ChangeRequestsPage'
import NotificationsPage from '@/pages/NotificationsPage'
import NotesPage from '@/pages/NotesPage'
import PreferencesPage from '@/pages/PreferencesPage'
import AllPreferencesPage from '@/pages/AllPreferencesPage'
import { TagManagementPage } from '@/pages/TagManagementPage'
import ContactsPage from '@/pages/ContactsPage'
import ContactListsPage from '@/pages/ContactListsPage'
import ProjectsPage from '@/pages/ProjectsPage'
import ProjectDetailPage from '@/pages/ProjectDetailPage'
import Layout from '@/components/Layout'
import ErrorBoundary from '@/components/ErrorBoundary'

const App: React.FC = () => {
  const { user, loading } = useAuth()
  
  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    )
  }

  if (!user) {
    return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    )
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/users" element={<UsersPage />} />
        <Route path="/shift-types" element={<ShiftTypesPage />} />
        <Route path="/schedule" element={<SchedulePage />} />
        <Route path="/calendar" element={<CalendarPage />} />
        <Route path="/change-requests" element={
          <ErrorBoundary>
            <ChangeRequestsPage />
          </ErrorBoundary>
        } />
        <Route path="/notifications" element={<NotificationsPage />} />
        <Route path="/notes" element={<NotesPage />} />
        <Route path="/preferences" element={<PreferencesPage />} />
        <Route path="/all-preferences" element={<AllPreferencesPage />} />
        <Route path="/tags" element={<TagManagementPage />} />
        <Route path="/contacts" element={<ContactsPage />} />
        <Route path="/contact-lists" element={<ContactListsPage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/projects/:id" element={<ProjectDetailPage />} />
        <Route path="/admin/permissions" element={<AdminPermissionsPage />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Layout>
  )
}

export default App 